import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSelectionListChange } from '@angular/material/list/selection-list';
import { LegislationGroup, LegislationRecipient, LegislationRecipientGroup } from 'app/legislation/legislation-items/legislation';
import { LegislationService } from 'app/_services/legislation.service';
import { NotificationService } from 'app/_services/notification.service';
import { catchError, of, throwError } from 'rxjs';

export enum CategoryTypes {
    CalendarEvents = 'calendarEvents',
    HallOfFame = 'hof',
}
@Component({
    selector: 'app-group-tags',
    templateUrl: './group-tags.component.html',
    styleUrls: ['./group-tags.component.scss'],
})
export class GroupTagsComponent implements OnInit, AfterViewInit {
    @Input() recipient: LegislationRecipient;
    @Input() groups: LegislationGroup[];


    // @Input() categories: any[];
    // @Input() categoryNames: string[];
    // @Input() itemCategories: any;
    // @Input() items: any;
    // @Input() itemName: string;
    // @Input() itemId: number;
    // @Input() categoryType: string;

       
    // [itemCategories]="event.eventCategories"
    // [items]="calendarEvents"
    // [itemName]="event.eventName"
    // [itemId]="event.eventId"
    // [categories]="categoryTags"
    // [categoryNames]="categoryNames"
    // categoryType="calendarEvents"
    // key="eventName"
    // localStorageKey="events"

    @Output() clickedItem = new EventEmitter<string>();
    groupsControl: FormControl;

    constructor(
        private cd: ChangeDetectorRef,
        private legislationService: LegislationService,
        private notificationService: NotificationService
    ) {}

    ngOnInit(): void {
        this.groupsControl = new FormControl(this.recipient.recipientGroups);
    }

    ngAfterViewInit() {
        this.cd.detectChanges();
    }

    onGroupRemoved(group: LegislationGroup): void {
        const self = this;
        const groupTags = self.groupsControl.value;

        const index = groupTags.indexOf(group);

        if (index >= 0) {
            groupTags.splice(index, 1);
        }

        self.groupsControl.setValue(groupTags); // To trigger change detection
        self.removeGroup(group);
    }

    updateGroupTags(event?: MatSelectionListChange): void {
        const self = this;
        if (event.option.selected) {
            self.addGroup(event.option.value);
        } else {
            self.removeGroup(event.option.value);
        }
    }

    // Compare function will autmatically compare the FormControl values with the list of groups
    compare(c1: { groupName: string }, c2: { groupName: string }) {
        return c1 && c2 && c1.groupName === c2.groupName;
    }

    addGroup(group: any) {
        const self = this;
        const newRecipientGroup: LegislationRecipientGroup = {
            recipientGroupId: 0, // Set to 0 since this is set to Identity column in database
            recipientId: self.recipient.recipientId,
            groupId: group.groupId,
        };

        self.legislationService.createLegislationRecipientGroup(newRecipientGroup)
            .pipe(catchError( err => {
                self.notificationService.showError('ERROR: Update failed due to incorrect group type.');
                return throwError(err);
            }))
            .subscribe();
    }

    removeGroup(group: any) {
        const self = this;
        const recipient = self.recipient;
        
        self.legislationService.getLegislationRecipientGroupsByRecipientId(recipient.recipientId).subscribe( (recipientGroups: LegislationRecipientGroup[]) => {
            let recGroup = recipientGroups.find((rg: LegislationRecipientGroup) => rg.groupId === group.groupId && rg.recipientGroupId === group.recipientGroupId)
            
            self.legislationService.deleteLegislationRecipientGroup(recGroup.recipientGroupId)
            .pipe(catchError( err => {
                self.notificationService.showError('ERROR: Deletion Failed.');
                return throwError(err);
            }))
            .subscribe();
        });
    }
}
